import { useEffect, useState } from "react";
import { useFilters } from "../../context/FiltersContext";

import "./index.css";

const ProductsList = () => {
  const [products, setProducts] = useState([]);

  const { category, minPrice, maxPrice, searchInput } = useFilters();

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    const response = await fetch("https://fakestoreapi.com/products");
    const data = await response.json();
    setProducts(data);
  };

  const filteredProducts = products.filter((product) => {
    const matchesCategory = category ? product.category === category : true;
    const matchesMinPrice = product.price >= minPrice;
    const matchesMaxPrice = product.price <= maxPrice;
    const matchesSearchInput = product.title
      .toLowerCase()
      .includes(searchInput.toLowerCase());
    return matchesCategory && matchesMinPrice && matchesMaxPrice && matchesSearchInput;
  });

  return (
    <div className="product-list">
      {filteredProducts.map((product) => (
        <div key={product.id} className="product-card">
          <img className="product-image" src={product.image} alt={product.title} />
          <h3 className="product-title">{product.title}</h3>
          <p>{product.description.slice(0, 80)}</p>
          <p>{product.rating.rate}</p>
          <p className="product-price">${product.price}</p>
        </div>
      ))}
    </div>
  );
};

export default ProductsList;
